import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const WinnerPopupLazy = React.lazy(() =>
  import('./WinnerPopup').then((m) => ({ default: m.WinnerPopup })),
);
type WinnerPopupProps = React.ComponentProps<typeof import('./WinnerPopup').WinnerPopup>;

NiceModal.register(
  MODALS.WINNER_POPUP,
  NiceModal.create((props: WinnerPopupProps) => (
    <Suspense fallback={null}>
      <WinnerPopupLazy {...props} />
    </Suspense>
  )),
);
